import { Stack } from "@mui/material";
import { Form as FormikForm } from "formik";
import { type FC, type PropsWithChildren } from "react";
import FormSubmit from "./Submit";

export interface FormProps {
	className?: string;
	spacing?: number;
	actions?: JSX.Element;
	isSubmitDisabled?: boolean;
	showSubmitButton?: boolean;
}

const Form: FC<PropsWithChildren<FormProps>> = ({
	children,
	actions,
	spacing = 4,
	isSubmitDisabled = false,
	showSubmitButton = true,
	...rest
}) => {
	return (
		<FormikForm
			noValidate // you need this to turn off browser default validation, thank this, all errors show up at once
			{...rest}
		>
			<Stack spacing={spacing}>
				{children}
				<Stack
					direction={{ xs: "column", md: "row" }}
					spacing={{ xs: 0, md: 4 }}
					justifyContent="space-between"
				>
					{actions}
					{showSubmitButton && (
						<FormSubmit
							disabled={isSubmitDisabled}
							sx={{
								flexGrow: actions ? 0 : 1,
								minWidth: "164px",
							}}
							text={{
								submitting: "Zpracovávám...",
								label: "Potvrdit",
							}}
						/>
					)}
				</Stack>
			</Stack>
		</FormikForm>
	);
};

export default Form;
